var _rect, _circle, _circle2, _circle3, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMirrorProjectorConsole2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 215,
    viewBox: "0 0 116 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 113.5,
    y: 212.5,
    width: 111,
    height: 119,
    rx: 7.5,
    transform: "rotate(-180 113.5 212.5)",
    stroke: "#D6AF66",
    strokeWidth: 5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 153,
    r: 10.5,
    fill: "#D6AF66",
    stroke: "#D6AF66",
    strokeWidth: 5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 153,
    r: 10.5,
    stroke: "#D6AF66",
    strokeWidth: 5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 36.5,
    r: 36.5,
    fill: "#D6AF66"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 19.5,
    width: 26,
    height: 36,
    stroke: "#960018",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.3938 55V39.2143M63 38L61.7826 43.4643L55.3938 39.2143L49 47.7143",
    stroke: "#960018",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54 31.5C54 31.8978 54.158 32.2794 54.4393 32.5607C54.7206 32.842 55.1022 33 55.5 33C55.8978 33 56.2794 32.842 56.5607 32.5607C56.842 32.2794 57 31.8978 57 31.5C57 31.1022 56.842 30.7206 56.5607 30.4393C56.2794 30.158 55.8978 30 55.5 30C55.1022 30 54.7206 30.158 54.4393 30.4393C54.158 30.7206 54 31.1022 54 31.5Z",
    fill: "#960018",
    stroke: "#960018",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirrorProjectorConsole2);
export default __webpack_public_path__ + "static/media/mirror-projector-console-2.5563e407755ea8d0abfef48db35dc517.svg";
export { ForwardRef as ReactComponent };